<div class="breadcrumb">
  <div
    class="breadcrumb__bar"
    [ngStyle]="{ width: (100 * (numberOfStepExecuted$ | async)) / (numberOfSteps$ | async) + '%' }"
  ></div>
</div>
